import { render, staticRenderFns } from "./WorkTransfer.vue?vue&type=template&id=142db86e&scoped=true"
import script from "./WorkTransfer.vue?vue&type=script&lang=js"
export * from "./WorkTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142db86e",
  null
  
)

export default component.exports